import { Grid2 } from '@mui/material'
import Select from 'components/forms/Select'
import QualityAction from 'quality/actions/QualityAction'
import { RESEARCH_TYPE } from 'quality/constants/QualityConstants'
import React, { useEffect } from 'react'
import i18n from 'simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import useParseJson from 'utils/customHook/useParseJson'
import Input from 'components/forms/Input'
import PropTypes from 'prop-types'

const QualityResearchJob = ({
    job = {},
    onChangeJob = () => {},
    isEditMode = false,
}) => {
    const dispatch = useDispatch()

    const {
        savedResearchs,
    } = useSelector(store => ({
        savedResearchs: store.QualityReducer.savedResearchs,
    }), shallowEqual)

    useEffect(() => {
        dispatch(QualityAction.fetchSavedResearchs())
    }, [dispatch])

    const {
        json: parameters,
    } = useParseJson(job.parameters.parameters[0] ?? '{}')

    const filteredSavedResearchs = savedResearchs.filter(r => r.researchType === RESEARCH_TYPE.WATER)

    const exportFormat = [
        { id: 'XLSX', label: i18n.exportXLSX },
        { id: 'CSV', label: i18n.exportCSV },
        { id: 'JSON', label: i18n.exportJSON },
    ]

    const slidingPeriods = [
        { id: 'DAY', label: i18n.day },
        { id: 'WEEK', label: i18n.week },
        { id: 'MONTH', label: i18n.month },
    ]

    const onChange = (change) => {
        onChangeJob({
            parameters: {
                ...job.parameters,
                parameters: [JSON.stringify({ ...parameters, ...change })],
            },
        })
    }

    return (
        <Grid2 container spacing={1} alignItems='center'>
            <Grid2 size={6}>
                <Select
                    label={i18n.qualityResearch}
                    options={filteredSavedResearchs}
                    value={parameters.researchId}
                    obligatory
                    keyLabel='title'
                    keyValue='id'
                    onChange={v => onChange({ researchId: v })}
                    disabled={!isEditMode}
                />
            </Grid2>
            <Grid2 size={3}>
                <Select
                    label={i18n.slidingPeriod}
                    options={slidingPeriods}
                    value={parameters.slidingPeriod}
                    onChange={v => onChange({ slidingPeriod: v })}
                    disabled
                />
            </Grid2>
            <Grid2 size={3}>
                <Select
                    label={i18n.exportFormat}
                    options={exportFormat}
                    value={parameters.format}
                    noNullValue
                    obligatory
                    onChange={v => onChange({ format: v })}
                    disabled={!isEditMode}
                />
            </Grid2>
            <Grid2 size={6}>
                <Input
                    title={i18n.selectDirectory}
                    value={parameters.repository}
                    obligatory
                    onChange={v => onChange({ repository: v })}
                    disabled={!isEditMode}
                />
            </Grid2>
        </Grid2>
    )
}

QualityResearchJob.propTypes = {
    job: PropTypes.shape({}),
    onChangeJob: PropTypes.func,
    isEditMode: PropTypes.bool,
}

export default QualityResearchJob